import { useEffect } from "react";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";

import { termsType } from "@models/components/booking.model";
import bookingSlice from "@slices/booking.slice";
import { RootState } from "@store/index";

const Terms = ({ gdpr, gdprTerms, legal_terms, termsService }: termsType) => {
  const dispatch = useDispatch();
  const { gdprAccepted, legalTermsAccepted, selectedSlot } = useSelector(
    (State: RootState) => State.booking
  );
  useEffect(() => {
    if (!termsService) {
      dispatch(bookingSlice.actions.acceptLegalTerms(true));
    }
    if (!gdprTerms) {
      dispatch(bookingSlice.actions.acceptGdpr(true));
    }
  }, [selectedSlot]);

  return (
    <div className="row" data-testid="terms-test">
      <div className="col-sm-12">
        <div className="switch-group">
          {termsService && (
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                checked={legalTermsAccepted}
                onChange={() => {
                  dispatch(
                    bookingSlice.actions.acceptLegalTerms(!legalTermsAccepted)
                  );
                }}
              />
              <label className="form-check-label" htmlFor="legalTermsAccepted">
                {t("iAcceptTheLocationLegalTerm")}
                <a href={legal_terms} target="_blank" rel="noreferrer">
                  {t("readHere")}
                </a>
              </label>
            </div>
          )}
          {gdprTerms && (
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                checked={gdprAccepted}
                onChange={() => {
                  dispatch(bookingSlice.actions.acceptGdpr(!gdprAccepted));
                }}
              />
              <label className="form-check-label" htmlFor="gdprAccepted">
                {t("iAcceptTheLocationGDPR")}
                <a href={gdpr} target="_blank" rel="noreferrer">
                  {" "}
                  {t("readHere")}
                </a>
              </label>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Terms;
